import { useTranslation } from 'react-i18next';

export default function RoadmapSection() {
  const { t } = useTranslation();

  const phases = [
    {
      number: t('roadmap.p1.number'),
      title: t('roadmap.p1.title'),
      color: '#00ff41',
      target: t('roadmap.p1.target'),
      actions: [t('roadmap.p1.a1'), t('roadmap.p1.a2'), t('roadmap.p1.a3')]
    },
    {
      number: t('roadmap.p2.number'),
      title: t('roadmap.p2.title'),
      color: '#00d9ff',
      target: t('roadmap.p2.target'),
      actions: [t('roadmap.p2.a1'), t('roadmap.p2.a2'), t('roadmap.p2.a3')]
    },
    {
      number: t('roadmap.p3.number'),
      title: t('roadmap.p3.title'),
      color: '#ff006e',
      target: t('roadmap.p3.target'),
      actions: [t('roadmap.p3.a1'), t('roadmap.p3.a2'), t('roadmap.p3.a3')]
    }
  ];

  return (
    <section id="roadmap" className="relative py-24 bg-gradient-to-b from-[#16213e] to-[#0a0118] overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `repeating-linear-gradient(0deg, #00ff41 0px, #00ff41 1px, transparent 1px, transparent 30px),
                           repeating-linear-gradient(90deg, #00ff41 0px, #00ff41 1px, transparent 1px, transparent 30px)`
        }}></div>
      </div>

      <div className="absolute inset-0 overflow-hidden">
        {[...Array(20)].map((_, i) => (
          <div key={i} className="absolute w-1 h-1 bg-[#00ff41] rounded-full"
            style={{
              left: '0%',
              top: `${(i * 7) % 100}%`,
              animation: `flowRight ${10 + (i % 5) * 2}s linear infinite`,
              animationDelay: `${(i % 6) * 0.8}s`,
              opacity: 0.3
            }}
          />
        ))}
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="text-center mb-20">
          <div className="inline-block px-4 py-2 bg-[#00ff41]/10 border border-[#00ff41] text-[#00ff41] text-xs font-['JetBrains_Mono'] font-semibold mb-6"
            style={{ clipPath: 'polygon(0 0, calc(100% - 6px) 0, 100% 6px, 100% 100%, 6px 100%, 0 calc(100% - 6px))' }}
          >
            {t('roadmap.sectionTag')}
          </div>
          <h2 className="text-4xl md:text-6xl font-bold text-white font-['Space_Grotesk'] mb-4">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#00ff41] via-[#00d9ff] to-[#ff006e]">
              {t('roadmap.title')}
            </span>
          </h2>
          <p className="text-gray-400 font-['JetBrains_Mono'] text-sm">{t('roadmap.subtitle')}</p>
        </div>

        <div className="relative">
          <div className="hidden md:block absolute top-32 left-0 right-0 h-1 bg-gradient-to-r from-[#00ff41] via-[#00d9ff] to-[#ff006e] opacity-30"></div>

          <div className="grid md:grid-cols-3 gap-8 md:gap-6">
            {phases.map((phase, index) => (
              <div key={index} className="relative">
                <div className="flex justify-center mb-6">
                  <div
                    className="relative w-24 h-24 flex items-center justify-center font-['JetBrains_Mono'] font-bold text-2xl text-black"
                    style={{ backgroundColor: phase.color }}
                  >
                    <div className="absolute inset-0 animate-ping opacity-20" style={{ backgroundColor: phase.color }}></div>
                    <span className="relative z-10">{index + 1}</span>
                    <div className="absolute top-0 left-0 w-3 h-3 bg-black"></div>
                    <div className="absolute top-0 right-0 w-3 h-3 bg-black"></div>
                    <div className="absolute bottom-0 left-0 w-3 h-3 bg-black"></div>
                    <div className="absolute bottom-0 right-0 w-3 h-3 bg-black"></div>
                  </div>
                </div>

                {index < phases.length - 1 && (
                  <div className="hidden md:block absolute top-12 left-[60%] w-[80%] h-0.5 bg-gradient-to-r opacity-50"
                    style={{ backgroundImage: `linear-gradient(to right, ${phase.color}, ${phases[index + 1].color})` }}
                  >
                    <div className="absolute right-0 top-1/2 transform -translate-y-1/2">
                      <div className="w-0 h-0 border-t-4 border-b-4 border-l-8 border-transparent"
                        style={{ borderLeftColor: phases[index + 1].color }}
                      ></div>
                    </div>
                  </div>
                )}

                <div
                  className="bg-[#1a0b2e]/50 backdrop-blur-sm border-2 p-6 hover:scale-105 transition-all duration-500 group"
                  style={{
                    clipPath: 'polygon(0 0, calc(100% - 14px) 0, 100% 14px, 100% 100%, 14px 100%, 0 calc(100% - 14px))',
                    borderColor: phase.color
                  }}
                >
                  <div className="text-xs font-['JetBrains_Mono'] font-bold mb-2" style={{ color: phase.color }}>
                    {phase.number}
                  </div>
                  <h3 className="text-2xl font-bold text-white font-['Space_Grotesk'] mb-2">{phase.title}</h3>

                  <div className="mb-4">
                    <div className="text-xs font-['JetBrains_Mono'] font-bold mb-2" style={{ color: phase.color }}>TARGET://</div>
                    <p className="text-gray-300 text-sm leading-relaxed">{phase.target}</p>
                  </div>

                  <div>
                    <div className="text-xs font-['JetBrains_Mono'] font-bold mb-2" style={{ color: phase.color }}>ACTION://</div>
                    <ul className="space-y-2">
                      {phase.actions.map((action, idx) => (
                        <li key={idx} className="flex items-start gap-2">
                          <span className="text-lg mt-0.5 flex-shrink-0" style={{ color: phase.color }}>■</span>
                          <span className="text-gray-400 text-sm leading-relaxed">{action}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div
                    className="absolute inset-0 opacity-0 group-hover:opacity-10 transition-opacity duration-500 pointer-events-none"
                    style={{
                      background: `radial-gradient(circle at center, ${phase.color}, transparent)`,
                      clipPath: 'polygon(0 0, calc(100% - 14px) 0, 100% 14px, 100% 100%, 14px 100%, 0 calc(100% - 14px))'
                    }}
                  ></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes flowRight {
          0% { transform: translateX(0); opacity: 0; }
          10% { opacity: 0.3; }
          90% { opacity: 0.3; }
          100% { transform: translateX(100vw); opacity: 0; }
        }
      `}</style>
    </section>
  );
}
